import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type SearchType = {
    [key: string]: string | number | undefined;
};

interface ContainersState {
    filterValue: string | undefined;
    searchError: string | undefined;
    currentPage: number;
    search: SearchType | undefined;
}

const initialState: ContainersState = {
    filterValue: undefined,
    searchError: undefined,
    currentPage: 1,
    search: undefined,
};

const containersSlice = createSlice({
    name: 'containers',
    initialState,
    reducers: {
        setContainersFilterValue: (state, action: PayloadAction<string | undefined>) => {
            state.filterValue = action.payload;
        },
        setContainersSearchError: (state, action: PayloadAction<string | undefined>) => {
            state.searchError = action.payload;
        },
        resetContainersFilterValue: state => {
            state.filterValue = undefined;
        },
        setContainersCurrentPage: (state, action: PayloadAction<number>) => {
            state.currentPage = action.payload;
        },
        setContainersSearch: (state, action: PayloadAction<SearchType>) => {
            state.search = action.payload;
        },
        resetContainersCurrentPage: state => {
            state.currentPage = 1;
        },
    },
});

export const {
    setContainersFilterValue,
    resetContainersFilterValue,
    setContainersSearchError,
    setContainersCurrentPage,
    resetContainersCurrentPage,
    setContainersSearch,
} = containersSlice.actions;

export default containersSlice.reducer;
